/* src/app/views/area-publica/home-page/card-passos-implementacao/card-passos-implementacao.component.scss */
.passo-item {
  background-color: #FFFFFF;
  width: 100%;
  border-radius: 45px;
  padding: 9px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
  margin-bottom: 8px;
}
.passo-item .icon-name {
  display: flex;
  align-items: center;
}
.passo-item .icon-name .icon {
  border-radius: 100%;
  background-color: #80bde0;
  width: 77px;
  height: 77px;
  display: flex;
  align-items: center;
}
.passo-item .icon-name .icon img {
  margin: auto;
}
.passo-item .icon-name .title {
  font: normal normal medium 24px/30px "Alegreya Sans Medium", sans-serif;
  letter-spacing: 0px;
  color: #757575;
  margin-left: 24px;
}
.passo-item-solo {
  width: 100%;
  height: 360px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1607843137);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;
  margin-left: 8px;
  margin-right: 8px;
  padding: 10px 10px 25px 10px;
}
.passo-item-solo .icon {
  border-radius: 100%;
  background-color: #80bde0;
  display: flex;
  align-items: center;
  margin: auto;
  margin-bottom: 0;
  margin-top: 0;
}
.passo-item-solo .icon img {
  margin: auto;
  width: 200px;
  height: 200px;
}
.passo-item-solo .title {
  font: normal normal normal 24px/30px "Alegreya Sans Medium", sans-serif;
  letter-spacing: 0px;
  color: #757575;
  margin: auto;
  text-align: center;
  overflow-wrap: normal;
}
.item-carousel {
  padding: 20px 10px 20px 10px;
  margin: 10px;
}
* > :host ::ng-deep .mat-button-wrapper div span {
  color: #007ac2 !important;
}
/*# sourceMappingURL=card-passos-implementacao.component.css.map */
